import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { NEvents } from '../interfaces/services/events.interfaces'
import { createUrl } from './helpers'
import axiosAuth from './config'

export const getEventsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NEvents.NGetPerSocieties.IResponse>> => {
  return axiosAuth.get<NEvents.NGetPerSocieties.IResponse>(
    createUrl(`/events/get-per-society/${societyId}`)
  )
}

export const getEvent = (
  id: string
): Promise<AxiosResponse<NEvents.NGetById.IResponse>> => {
  return axiosAuth.get<NEvents.NGetById.IResponse>(
    createUrl(`/events/event/${id}`)
  )
}

export const createEvent = (
  body: NEvents.NCreate.IRequestBody
): Promise<AxiosResponse<NEvents.NCreate.IResponse>> => {
  return axiosAuth.post<NEvents.NCreate.IResponse>(
    createUrl(`/events/event`),
    body
  )
}

export const updateEvent = (params: {
  id: string
  body: NEvents.NPatch.IRequestBody
}): Promise<AxiosResponse<NEvents.NPatch.IResponse>> => {
  return axiosAuth.patch<NEvents.NPatch.IResponse>(
    createUrl(`/events/event/${params.id}`),
    params.body
  )
}

export const deleteEvent = (variables: {
  id: string
  queryParameters: NEvents.NDel.IRequestQuery
}): Promise<AxiosResponse<NEvents.NDel.IResponse>> => {
  return axiosAuth.delete<NEvents.NDel.IResponse>(
    createUrl(`/events/event/${variables.id}`, { ...variables.queryParameters })
  )
}

export const eventAttendance = (
  id: string,
  body: NEvents.NAttendance.IRequestBody
): Promise<AxiosResponse<NEvents.NAttendance.IResponse>> => {
  return axiosAuth.post<NEvents.NAttendance.IResponse>(
    createUrl(`/events/event/${id}/attendance`),
    body
  )
}

export const getEventAttendanceList = async (
  id: string
): Promise<AxiosResponse<NEvents.NGetAttendanceList.IResponse>> => {
  return axiosAuth.get<NEvents.NGetAttendanceList.IResponse>(
    createUrl(`/events/event/${id}/attendance-list`)
  )
}

export const eventQueries = {
  getEvent: (eventId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'events', entity: 'detail', eventId }],
      queryFn: async ({ queryKey }) =>
        (await getEvent(queryKey[0].eventId!)).data.data,
      enabled: !!eventId,
    }),
  getEventsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'events', entity: 'list', societyId }],
      queryFn: async ({ queryKey }) => {
        return (await getEventsPerSociety(queryKey[0].societyId!)).data.data
      },
      enabled: !!societyId,
    }),
}
